// Each field has: name, label, optional type, optional source.
// `optional: true` means the field is NOT required at submit time.
// Section-level `optional: true` makes EVERY field in that section optional.
export const LEAD_SECTIONS = [
  {
    title: "Lead Identity",
    fields: [
      { name: "campaign_name", label: "Campaign Name", type: "select-dynamic", source: "campaigns" },
      { name: "date", label: "Date", type: "date", optional: true },
      { name: "lead_id", label: "Lead ID", optional: true },
      { name: "campaign_type", label: "Campaign Type", type: "select-dynamic", source: "campaign_types" },
      { name: "agent_name", label: "Agent Name", type: "select-dynamic", source: "agents" },
      { name: "first_name", label: "First Name" },
      { name: "last_name", label: "Last Name" },
      { name: "opt_in", label: "Opt-In", type: "select", options: ["Yes", "No"] },
    ],
  },
  {
    title: "Contact Info",
    fields: [
      { name: "work_email", label: "Work Email", type: "email" },
      { name: "alternate_email", label: "Alternate Email", type: "email", optional: true },
      { name: "work_phone", label: "Work Phone", type: "phone" },
      { name: "direct_number", label: "Direct Number", optional: true },
      { name: "ext", label: "Ext", optional: true },
      { name: "language", label: "Language" },
    ],
  },
  {
    title: "Company & Role",
    fields: [
      { name: "company_name", label: "Company Name" },
      { name: "domain", label: "Domain" },
      { name: "website", label: "Website" },
      { name: "job_title", label: "Job Title" },
      { name: "job_function", label: "Job Function" },
      { name: "job_role", label: "Job Role" },
      { name: "department", label: "Department", type: "select", source: "departments" },
      { name: "segment", label: "Segment", optional: true },
      { name: "global_employee_size", label: "Global Employee Size", type: "select", source: "employee_sizes" },
      { name: "revenue_size", label: "Revenue Size", type: "select", source: "revenue_sizes" },
      { name: "linkedin_industry", label: "LinkedIn Industry", type: "select", source: "linkedin_industries" },
      { name: "client_industry", label: "Client Industry mapping" },
    ],
  },
  {
    title: "Location",
    fields: [
      { name: "address1", label: "Address 1" },
      { name: "address2", label: "Address 2", optional: true },
      { name: "city", label: "City" },
      { name: "state", label: "State" },
      { name: "zip_code", label: "Zip Code" },
      { name: "country", label: "Country", type: "select", source: "countries" },
    ],
  },
  {
    title: "Assets & Email Status",
    optional: true,
    fields: [
      { name: "asset_name_1", label: "Asset Name 1" },
      { name: "email_asset_status_1", label: "Email Asset Status 1", type: "select", source: "email_asset_statuses" },
      { name: "asset_name_2", label: "Asset Name 2" },
      { name: "email_asset_status_2", label: "Email Asset Status 2", type: "select", source: "email_asset_statuses" },
      { name: "asset_name_3", label: "Asset Name 3" },
      { name: "email_asset_status_3", label: "Email Asset Status 3", type: "select", source: "email_asset_statuses" },
      { name: "asset_name_4", label: "Asset Name 4" },
      { name: "email_asset_status_4", label: "Email Asset Status 4", type: "select", source: "email_asset_statuses" },
    ],
  },
  {
    title: "Social & Web Links",
    fields: [
      { name: "linkedin_company_link", label: "LinkedIn Company Link" },
      { name: "linkedin_prospect_link", label: "LinkedIn Prospect Link" },
      { name: "revenue_link", label: "Revenue Link" },
    ],
  },
  {
    title: "Audit & QA",
    optional: true,
    fields: [
      { name: "qa_audit_status", label: "QA Audit Status", type: "select", source: "qa_audit_statuses" },
      { name: "tc_name", label: "TC Name" },
      { name: "qa_name", label: "QA Name" },
      { name: "data_comments", label: "DATA Comments", type: "textarea" },
      { name: "lg_comments", label: "LG Comments", type: "textarea" },
      { name: "qa_comments", label: "QA Comments", type: "textarea" },
    ],
  },
];

export const EMPTY_LEAD = {
  ...LEAD_SECTIONS.flatMap((s) => s.fields).reduce(
    (acc, f) => ({ ...acc, [f.name]: "" }),
    {}
  ),
  // Inline survey answers (admin-defined per campaign) populated by
  // the Add Lead form's question block. Map of question_id → answer.
  survey_answers: {},
};

// Flat list of every required-by-default field name (for submit validation).
export const REQUIRED_FIELD_NAMES = LEAD_SECTIONS.flatMap((section) =>
  section.optional
    ? []
    : section.fields.filter((f) => !f.optional).map((f) => f.name)
);

export const STATUS_TONE = {
  // Email Asset Status
  "Email sent": "badge-info",
  "Pending": "badge-warning",
  "Delivered": "badge-success",
  "Bounce": "badge-error",
  "Unsubscribed": "badge-neutral",
  // QA Audit
  "Approved": "badge-success",
  "Rejected": "badge-error",
  "Re-audit": "badge-warning",
  "Invalid-data": "badge-error",
};
